import "@fontsource-variable/inter";
import "@fontsource-variable/jetbrains-mono";
import "./styles.css";
import { applyPreferences, LiveProvider, registerErrorTexts, settleSkippedViewTransitions } from "@nexxt/app-kit";
import { registerCatalogClient } from "@nexxt/catalog-ui";
import { registerLogisticsClient } from "@nexxt/logistics-ui";
import { registerPartyClient } from "@nexxt/party-ui";
import { registerProcurementClient, registerProcurementTexts } from "@nexxt/procurement-ui";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { queryClient } from "./api";
import { catalogClient } from "./catalog-client";
import { errorTexts } from "./errors";
import { procurementTexts } from "./features/procurement/procurement-texts";
import { logisticsClient } from "./logistics-client";
import { partyClient } from "./party-client";
import { procurementClient } from "./procurement-client";
import { router } from "./router";

registerErrorTexts(errorTexts);
registerCatalogClient(catalogClient);
registerLogisticsClient(logisticsClient);
registerPartyClient(partyClient);
registerProcurementClient(procurementClient);
registerProcurementTexts(procurementTexts);
settleSkippedViewTransitions();
applyPreferences();
matchMedia("(prefers-color-scheme: dark)").addEventListener("change", applyPreferences);

const root = document.getElementById("root");
if (!root) throw new Error("#root is missing from index.html");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <LiveProvider>
        <RouterProvider router={router} />
      </LiveProvider>
    </QueryClientProvider>
  </StrictMode>,
);
